import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilCalculator,
  cilChartPie,
  cilCursor,
  cilMemory,
  cil3d,
  cilCloud,
  cilDescription,
  cilDrop,
  cilSearch,
  cilCode,
  cilNotes,
  cilPencil,
  cilStream,
  cilLineWeight,
  cilChartLine,
  cilVerticalAlignCenter,
  cilPuzzle,
  cilChevronDoubleRight,
  cilArrowThickFromBottom,
  cilArrowThickToBottom,
  cilVector,
  cilApplications,
  cilBarChart,
  cilBank,
  cilCommentSquare,
  cilClearAll,
  cilBarcode,
  cilSpeedometer,
  cilStar,
  cilAccountLogout,
  cilShare,
  cilClipboard,
  cilAsterisk,
  cilBug,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'
import roleAccess from './roleAccess'

const getNavItems = (userRole) => {
  const allNavItems = [
    {
      component: CNavTitle,
      name: 'Experiments',
    },
    {
      component: CNavGroup,
      name: 'Upload',
      icon: <CIcon icon={cilArrowThickFromBottom} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: 'Datasets',
          to: '/upload/dataset',
        },
        {
          component: CNavItem,
          name: 'Sequences',
          to: '/upload/references',
        },
      ],
      className: 'nav-group-no-background',
    },
    {
      component: CNavItem,
      name: 'Manage',
      to: '/manage',
      icon: <CIcon icon={cilClipboard} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Share',
      to: '/share',
      icon: <CIcon icon={cilShare} customClassName="nav-icon" />,
    },
    {
      component: CNavTitle,
      name: 'Analyze',
    },
    {
      component: CNavItem,
      name: 'Basecall',
      to: '/analysis/basecall',
      icon: <CIcon icon={cilMemory} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Cluster',
      to: '/analysis/cluster',
      icon: <CIcon icon={cilStream} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Discover',
      to: '/analysis/discover',
      icon: <CIcon icon={cilVerticalAlignCenter} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Cloud Tasks',
      to: '/analysis/cloudtasks',
      icon: <CIcon icon={cilCloud} customClassName="nav-icon" />,
    },
    {
      component: CNavTitle,
      name: 'Results',
    },
    {
      component: CNavItem,
      name: 'Basecalls',
      to: '/visualize_basecalls',
      icon: <CIcon icon={cilBarChart} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Clustering',
      to: '/visualize_cluster',
      icon: <CIcon icon={cilClearAll} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Modifications',
      to: '/visualize_modifications',
      icon: <CIcon icon={cilAsterisk} customClassName="nav-icon" />,
    },
    {
      component: CNavTitle,
      name: 'Developer Tools',
    },
    {
      component: CNavItem,
      name: 'Panel',
      to: '/admin_panel',
      icon: <CIcon icon={cilCode} customClassName="nav-icon" />,
      badge: {
        color: 'dark',
        text: 'admin',
      },
    },
    {
      component: CNavItem,
      name: 'Invite',
      to: '/invite',
      icon: <CIcon icon={cilCode} customClassName="nav-icon" />,
      badge: {
        color: 'dark',
        text: 'admin',
      },
    },
    {
      component: CNavItem,
      name: 'Render Panel',
      to: '/developer/render_panel',
      icon: <CIcon icon={cilCode} customClassName="nav-icon" />,
      badge: {
        color: 'dark',
        text: 'admin',
      },
    },
    {
      component: CNavGroup,
      name: 'Tests',
      icon: <CIcon icon={cilCode} customClassName="nav-icon" />,
      items: [
        {
          component: CNavItem,
          name: 'Register',
          to: '/register_invited',
          badge: {
            color: 'dark',
            text: 'admin',
          },
        },
        {
          component: CNavItem,
          name: 'Test Elements',
          to: '/test_element',
          badge: {
            color: 'dark',
            text: 'admin',
          },
        },
        {
          component: CNavItem,
          name: 'Quality Metrics',
          to: '/visualize_qc',
          badge: {
            color: 'dark',
            text: 'admin',
          },
        },
        {
          component: CNavItem,
          name: 'Cluster',
          to: '/analysis/cluster',
          badge: {
            color: 'dark',
            text: 'admin',
          },
        },
        {
          component: CNavItem,
          name: 'Morph',
          to: '/analysis/morph',
          badge: {
            color: 'dark',
            text: 'admin',
          },
        },
        {
          component: CNavItem,
          name: 'Discover',
          to: '/analysis/morph',
          badge: {
            color: 'dark',
            text: 'admin',
          },
        },
        {
          component: CNavItem,
          name: 'Results',
          to: '/analysis/cloudresults',
          badge: {
            color: 'dark',
            text: 'admin',
          },
        },
      ],
      className: 'nav-group-no-background',
    },
    {
      component: CNavTitle,
      name: 'Alpha',
    },
    {
      component: CNavItem,
      name: 'Report Bug',
      to: '/report_bug',
      icon: <CIcon icon={cilBug} customClassName="nav-icon" />,
      badge: {
        color: 'warning',
        text: 'alpha',
      },
    },
    {
      component: CNavItem,
      name: 'Feedback',
      to: '/feedback',
      icon: <CIcon icon={cilCommentSquare} customClassName="nav-icon" />,
      badge: {
        color: 'warning',
        text: 'alpha',
      },
    },
    {
      component: CNavTitle,
      name: 'Account',
    },
    {
      component: CNavItem,
      name: 'Profile',
      to: '/profile/viewprofile',
      icon: <CIcon icon={cilMemory} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Settings',
      to: '/profile/settings',
      icon: <CIcon icon={cilApplications} customClassName="nav-icon" />,
      badge: {
        color: 'danger',
        text: 'dev',
      },
    },
    {
      component: CNavItem,
      name: 'Billing',
      to: '/profile/billing',
      icon: <CIcon icon={cilBank} customClassName="nav-icon" />,
      badge: {
        color: 'danger',
        text: 'dev',
      },
    },
    {
      component: CNavItem,
      name: 'Log out',
      to: '/logout', // Change to a route that will handle logout
      icon: <CIcon icon={cilAccountLogout} customClassName="nav-icon" />,
    },
  ]

  const filterItemsByRole = (items, role) => {
    const accessRole = roleAccess.hasOwnProperty(role) ? role : 'default'
    if (roleAccess[accessRole] === 'all') return items
    return items.filter((item) => !roleAccess[accessRole].includes(item.name))
  }
  // Return filtered nav items based on user role
  return filterItemsByRole(allNavItems, userRole || 'default')
}

export default getNavItems
